const resource = {
  "main": {
    "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 번역으로 한국과 일본을 더 가깝게 연결합니다."])},
    "tagline": {
      "line1": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["한국과 일본, "])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["더 가깝게"])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["."])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "line2": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI"])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["가 첫 인사부터 답장까지 도와주는 한일 매칭."])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "line3": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["일본어를 몰라도 자연스럽게 대화하세요.\n하루 3~5명의 엄선 추천, 실시간 번역,\n신분증 인증 기반의 안전한 만남을 제공합니다."])}
    }
  },
  "home": {
    "mealManagement": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI가 언어 장벽을\n실시간으로 낮춥니다"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["상대가 한국어 또는 일본어로 입력해도 MoTobi가 자연스럽게 번역합니다.\n\n- 대화 흐름에 맞는 실시간 번역\n- 어색한 표현을 부드럽게 다듬는 AI 문장 보정\n- 서로의 원문과 번역문을 함께 확인\n\n언어 때문에 멈추지 않고 대화를 이어갈 수 있습니다."])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 번역 대화 화면"])}
    },
    "mealInput": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["첫 인사와 답장을\nAI가 제안합니다"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["무슨 말을 해야 할지 막힐 때 AI 추천 메시지를 바로 사용할 수 있습니다.\n\n- 프로필 관심사 기반 첫 메시지 추천\n- 대화 분위기에 맞춘 답장 후보\n- 한국어와 일본어를 동시에 고려한 표현\n\n번역만이 아니라 자연스러운 시작까지 도와줍니다."])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 추천 메시지 화면"])}
    },
    "about": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["하루 3~5명만\n신중하게 추천합니다"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["무제한 스와이프 대신 관심사, 언어 수준, 관계 목적을 바탕으로 어울리는 사람을 선별합니다.\n\n- 친구, 연애, 언어교환 목적 반영\n- 한국/일본 문화 관심사 매칭\n- 피로감 없는 적은 수의 고품질 추천\n\n많이 넘기는 앱이 아니라 제대로 만나는 앱을 지향합니다."])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["오늘의 추천 보기"])}
    },
    "nutrition": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["신분증 인증으로\n안전한 환경을 만듭니다"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobi는 신뢰할 수 있는 한일 매칭을 위해 본인 인증 흐름을 강조합니다.\n\n- 신분증 기반 인증 배지\n- 유령회원과 스팸 계정 차단\n- 신고와 차단을 빠르게 처리하는 안전 장치\n\n처음 만나는 사람과도 안심하고 대화할 수 있어야 합니다."])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 프로필 보기"])}
    },
    "weight": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["관심사로 이어지는\n한일 문화 매칭"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["K-드라마, 일본 여행, 음악, 음식, 언어공부처럼 자연스럽게 대화가 시작되는 관심사를 연결합니다.\n\n- 문화 취향 태그\n- 언어교환 레벨 표시\n- 대화 주제 추천\n\n서로 궁금한 것이 있는 사람끼리 만나게 합니다."])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["관심사 매칭 보기"])}
    },
    "aboutPro": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["친구부터 연인까지\n목적에 맞게 연결합니다"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["가벼운 언어교환, 현지 친구, 진지한 만남까지 원하는 관계 목적을 분명히 보여줍니다.\n\n- 관계 목적 선택\n- 대화 속도와 언어 수준 반영\n- 매칭 전 프로필 신뢰 정보 확인\n\n서로 기대가 맞는 만남을 시작하세요."])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["프로필 둘러보기"])}
    },
    "formulas": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobi가 한일 사이를 더 가깝게"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 번역, 메시지 추천, 제한 추천, 인증 기반 안전성을 한 화면에서 제공합니다.\n\n- 한국어/일본어 대화 지원\n- 첫 메시지와 답장 제안\n- 하루 3~5명 엄선 추천\n\n언어의 부담은 줄이고 만남의 밀도는 높입니다."])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["자세히 보기"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobi 시작하기"])}
    },
    "statistics": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["한일 매칭을 위한 핵심 지표"])},
      "cards": {
        "app": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App Store"])},
          "rating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["출시 준비 중"])},
          "reviews": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobi 사전 등록 예정"])}
        },
        "play": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Google Play"])},
          "rating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["출시 준비 중"])},
          "reviews": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobi 사전 등록 예정"])}
        },
        "global": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["서비스 방향"])},
          "users": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["하루 3~5명 엄선 추천"])},
          "hours": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 실시간 번역 지원"])},
          "workouts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["신분증 인증 기반 안전 매칭"])}
        },
        "effect": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["핵심 가치"])},
          "rate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["언어 장벽 최소화"])},
          "retention": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["한국/일본 문화 관심사 연결"])},
          "drop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["스팸·유령회원 감소 목표"])}
        }
      },
      "foot": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobi는 한국과 일본을 더 가깝게 만드는 AI 매칭 서비스입니다."])},
      "note": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["* 수치는 출시 전 제품 컨셉 기준이며, 실제 운영 데이터 확보 후 업데이트가 필요합니다."])}
    }
  },
  "navigation": {
    "navbar": {
      "appTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobi"])},
      "languages": {
        "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["영어"])},
        "kr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["한국어"])},
        "jp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["일본어"])}
      },
      "subpages": {
        "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["더 알아보기"])},
        "appStore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["앱 스토어"])},
        "googlePlay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["구글 플레이"])},
        "formulas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulas"])},
        "books": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Books"])},
        "articles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Articles"])},
        "statistics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statistics"])},
        "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations"])},
        "donate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Donate"])}
      }
    },
    "footer": {
      "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["개인정보처리방침"])},
      "termsOfUse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["이용약관"])},
      "cookiePolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["쿠키 정책"])},
      "copyrights": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All photos and logos used are copyright-free and made available under the MIT or CC license. It is allowed to use, copy, modify or distribute the original or modified content on this website without restriction, provided that the authorship is acknowledged and the source information is posted."])}
    }
  },
  "sciences": {
    "groups": {
      "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
      "natural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Natural"])},
      "social": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Social"])},
      "humanities": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Humanities"])},
      "technical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technical"])},
      "artistic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artistic"])},
      "others": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Others"])}
    },
    "sciences": {
      "philology_iberian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iberian Philology"])},
      "philology_english": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English Philology"])},
      "philology_france": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["French and Benelux Philology"])},
      "philology_italian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italian Philology"])},
      "philology_german": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["German Philology"])},
      "philology_poland": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polish, Ukrainian and Lithuanian Philology"])},
      "philology_baltic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Baltic Philology"])},
      "philology_nordic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nordic Philology"])},
      "philology_russian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Russian Philology"])},
      "philology_carpathian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Carpathian Philology"])},
      "philology_romanian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Romanian nad Bulgarian Philology"])},
      "philology_balkan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["West-Balkan Philology"])},
      "philology_greek": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greek Philology"])},
      "philology_turkish": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turkish Philology"])},
      "philology_middleeast": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Middle East, Arabic and Persian Philology"])},
      "philology_indian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indian Philology"])},
      "philology_chinese": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chinese Philology"])},
      "philology_korean": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korean Philology"])},
      "philology_japanese": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Japanese Philology"])},
      "anthropology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anthropology"])},
      "philosophy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Philosophy"])},
      "history": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["History"])},
      "historyofart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["History of Art"])},
      "culturalstudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cultural Studies"])},
      "politology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Politology"])},
      "law": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Law"])},
      "psychology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Psychology"])},
      "theology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Theology"])},
      "defensestudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Defense Studies"])},
      "sociology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sociology"])},
      "internationalstudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["International Studies"])},
      "economics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Economics"])},
      "finances": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finances"])},
      "accountancy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accountancy"])},
      "econometrics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Econometrics"])},
      "governance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Governance"])},
      "management": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Management"])},
      "astronomy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Astronomy"])},
      "bioinformatics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bioinformatics"])},
      "biochemistry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biochemistry"])},
      "biophysics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biophysics"])},
      "biotechnology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biotechnology"])},
      "biology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biology"])},
      "chemistry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chemistry"])},
      "physics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Physics"])},
      "geography": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geography"])},
      "geology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geology"])},
      "informatics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informatics"])},
      "math": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mathematics"])},
      "ecology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ecology"])},
      "architecture": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Architecture"])},
      "robotics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Robotics"])},
      "building_eng": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Building Engeenering"])},
      "energetics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Energetics"])},
      "electronics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Electronics"])},
      "quantum_eng": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantum Engeenering"])},
      "cosmonautics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosmonautics"])},
      "mechanics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mechanics"])},
      "mechatronics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mechatronics"])},
      "transport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transport"])}
    },
    "branches": {
      "physics": {
        "kinematics": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinematics"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We study the motion of bodies, including their acceleration, path and speed"])},
          "subjects": {
            "linear-motion": {
              "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Linear Motion"])},
              "formulas": {
                "velocity-basic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average speed"])},
                "velocity-deriv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instantaneous speed"])},
                "acceleration-basic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average acceleration"])},
                "acceleration-deriv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instantaneous acceleration"])},
                "motion-eq-a": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 1"])},
                "motion-eq-b": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 2"])},
                "motion-eq-c": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 3"])},
                "motion-eq-d": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 4"])}
              }
            }
          }
        },
        "dynamics": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dynamika"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zajmiemy się opisem sił działających na różne ciała, a także ich skutkami"])}
        },
        "energy": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Energia"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Praca moc i energia to wielkości, które pozwolą nam spojrzeć na mechanikę z innej strony, a także będą wstępem do kolejnych działów fizyki."])}
        }
      },
      "electronics": {
        "current": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prąd elektryczny"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaczynamy od podstaw, czyli czym jest prąd elektryczny"])}
        }
      }
    },
    "units": {
      "velocity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prędkość"])},
      "distance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Droga"])},
      "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czas"])},
      "acceleration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przyspieszenie"])}
    }
  },
  "pages": {
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Strona główna"])},
    "formulas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tablice"])},
    "articles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artykuły"])},
    "books": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podręczniki"])},
    "statistics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statystyki"])},
    "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacje"])},
    "donate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wesprzyj"])}
  },
  "formulas": {
    "index": {
      "hero": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wzory i tablice naukowe"])}
    },
    "pick": {
      "science": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz jedną z kategorii"])},
      "branch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz dziedzinę nauki, która cię interesuje"])}
    }
  },
  "errors": {
    "404": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nasz system nie znalazł takiej strony :c"])},
      "duck": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Więc łap chociaż na pocieszenie kaczkę"])},
      "yeah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tak, to ten sławny bląd 404"])},
      "song": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bit, bit i pusta kartka, drukarka wydaje szmery Nie ma mnie, bo to nocnego marka nocna warta Świeci się tarcza zegarka - 4:04 Nic nie psuje atmosfery, dźwięki smarta czy wiertarka"])}
    }
  },
  "info": {
    "sure": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ale czy aby na pewno?"])},
    "sections": {
      "begginings": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Początki"])}
      },
      "activity": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Działalność"])}
      },
      "goalsandplans": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cel i plany"])}
      },
      "software": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oprogramowanie"])},
        "langscategories": {
          "front-end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Front-End"])},
          "back-end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back-End"])},
          "mobile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilne"])},
          "databases": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bazy danych"])},
          "others": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inne"])}
        }
      },
      "sponsors": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sponsorzy"])}
      },
      "authors": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorzy"])}
      },
      "thanks": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podziękowania"])}
      },
      "donate": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wesprzyj"])}
      },
      "join": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dołącz"])}
      },
      "contact": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontakt"])}
      }
    }
  }
}
export default resource